type StaticMetaTag = {
  name: string;
  value: string;
};

type DynamicMetaTag = {
  name: string;
  label: string;
  createOgTag?: boolean;
};

const STATIC_META: StaticMetaTag[] = [
  {
    name: 'og:type',
    value: 'website',
  },
  {
    name: 'viewport',
    value: 'width=device-width,initial-scale=1.0,user-scalable=no,viewport-fit=cover',
  },
  {
    name: 'og:URL',
    value: '',
  },
];

const DYNAMIC_META: DynamicMetaTag[] = [
  {
    name: 'title',
    label: 'Page title',
    createOgTag: true,
  },
  {
    name: 'description',
    label: 'Meta description',
    createOgTag: true,
  },
  {
    name: 'keywords',
    label: 'Meta keywords',
  },
];

export default function (editor) {
  let wrapper;

  const wrapperUpdate = () => {
    wrapper = editor.getWrapper();
    if (!wrapper) return;

    const traits = DYNAMIC_META.map(config => ({
      name: config.name === 'title' ? 'data-head-title' : `data-head-meta-${config.name}`,
      type: "text",
      label: config.label,
    }));

    wrapper.get("traits").add(traits);
  };

  editor.on("storage:loaded", () => {
    wrapperUpdate();
    const doc = editor.Canvas.getDocument() as HTMLDocument;
    
    DYNAMIC_META.forEach(config => {
      if (config.name === 'title') {
        wrapper.addAttributes({ 
          "data-head-title": doc.head.querySelector("title")?.innerHTML || "" 
        });
      } else {
        const meta = doc.head.querySelector<HTMLMetaElement>(`meta[name="${config.name}"]`);
        if (meta) {
          wrapper.addAttributes({ 
            [`data-head-meta-${config.name}`]: meta.content 
          });
        }
      }
    });
  });

  editor.on("storage:start:store", () => {
    const doc = editor.Canvas.getDocument() as HTMLDocument;
    const attributes = wrapper.getAttributes() as Record<string, string>;
    
    DYNAMIC_META.forEach(metaConfig => {
      const attrName = metaConfig.name === 'title' ? 'data-head-title' : `data-head-meta-${metaConfig.name}`;
      const content = attributes[attrName] || '';
      if (!content) return;

      if (metaConfig.name === 'title') {
        const title = doc.head.querySelector("title") || doc.head.appendChild(doc.createElement("title"));
        title.innerText = content;
      }
      const meta = doc.head.querySelector<HTMLMetaElement>(`meta[name="${metaConfig.name}"]`)
        || doc.head.appendChild(doc.createElement("meta"));
      meta.name = metaConfig.name;
      if (metaConfig.createOgTag) meta.setAttribute("property", `og:${metaConfig.name}`);
      meta.content = content;

    });

    STATIC_META.forEach(metaConfig => {
      if (metaConfig.name === 'og:URL') {
        const meta = doc.head.querySelector<HTMLMetaElement>(`meta[property="og:URL"]`)
          || doc.head.appendChild(doc.createElement("meta"));
        meta.setAttribute("property", "og:URL");
        meta.content = new URL(editor.StorageManager.getConfig().urlStore).origin
        return;
      }
      
      let meta = doc.head.querySelector<HTMLMetaElement>(`meta[name="${metaConfig.name}"]`) || doc.head.querySelector<HTMLMetaElement>(`meta[property="${metaConfig.name}"]`)
      if (meta) return;
      const isProperty = metaConfig.name.startsWith("og:");
      meta = doc.head.appendChild(doc.createElement("meta"));
      meta.setAttribute(isProperty ? 'property' : 'name', metaConfig.name);
      meta.content = metaConfig.value;
    });
  });
}
